import { render } from "./PromptCard.vue?vue&type=template&id=09d7280a&scoped=true"
import script from "./PromptCard.vue?vue&type=script&lang=js"
export * from "./PromptCard.vue?vue&type=script&lang=js"

import "./PromptCard.vue?vue&type=style&index=0&id=09d7280a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d7280a"]])

export default __exports__